export default __webpack_public_path__ + "static/media/service_area.937acc41.svg";